import React from "react";
import {ElementContainerProps, UIElementType} from "@data-force/app";
import {Form} from "antd";
import {FormItemProps} from "antd/lib/form";
import Nullable from "@data-force/app/interfaces/nullable";
import classNames from "classnames";
import MarkdownMedia from "../../Markdown/MarkdownMedia";

const Container: React.FC<ElementContainerProps> = (props: ElementContainerProps): React.ReactElement => {
    const {
        elementKey,
        label,
        required,
        fieldName,
        getFieldError,
        children,
        elementType,
        hidden,
        signType,
        invisible,
    }: ElementContainerProps = props;
    const errors: Nullable<FormItemProps> = getFieldError && getFieldError(fieldName) as FormItemProps;
    const labelElement: React.ReactNode = elementType && UIElementType.CHECKBOX === elementType
        ? undefined
        : (
            <div className="df-form-label-container">
                <MarkdownMedia signType={signType}>
                    {label}
                </MarkdownMedia>
            </div>
        );
    const classes: string = classNames({
        "df-form-item": true,
        "df-hidden": hidden || invisible,
    });

    return (
        <Form.Item
            className={classes}
            key={`${elementKey}-form-item`}
            label={labelElement}
            required={required}
            {...errors}
        >
            {children}
        </Form.Item>
    );
};

export default Container;
